import { React, useState, useEffect, useContext, lazy } from "react";
import { Context } from "../../utils/Context";

//database
import { getAllKeys } from "../../database/db";

//material UI
import { Grid, Typography } from "@mui/material";

//components
const GenderHeader = lazy(() => import("../../components/Header"));
const CustomButton = lazy(() => import("../../components/Button"));

export default function QuestionScreen() {
  const [dado, setDados] = useState([]);
  const [isLoading, setLoading] = useState(1);
  const { list } = useContext(Context);

  /*if (list === undefined) {
    throw new Error("Erro na execução da aplicação.");
  }*/

  useEffect(() => {
    //console.error("[question.js > useEffect()] passei aqui...");

    function generateUniqueRandom(maxNr) {
      let random = Number((Math.random() * maxNr).toFixed());
      //console.log(list);

      if (!list.includes(random)) {
        list.push(random);
        return random;
      } else {
        if (list.length < maxNr) {
          return generateUniqueRandom(maxNr);
        } else {
          console.log("No more numbers available.");
          return false;
        }
      }
    }

    async function fetchData() {
      const result = await getAllKeys("question");
      let item = JSON.parse(
        JSON.stringify(result[generateUniqueRandom(result.length - 1)])
      );
      setDados(item);
      setLoading(0);
    }
    fetchData();
  }, [list]);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        minHeight: "100vh",
      }}
    >
      <Grid item xs></Grid>
      <Grid item xs={10}>
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: {
              xs: "25%",
              sm: "5%",
              md: "5%",
              lg: "0",
              xl: "0",
            },
          }}
        >
          <Grid item xs={12}>
            <GenderHeader></GenderHeader>
          </Grid>
          {dado && (
            <>
              <Grid
                item
                xs={12}
                textAlign={"center"}
                sx={{
                  height: {
                    xs: "35vh",
                    sm: "50vh",
                    md: "45vh",
                    lg: "50vh",
                    xl: "50vh",
                  },
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + "/images/" + dado.image}
                  width={"95%"}
                  height={"100%"}
                  alt="Imagem exemplificativa de acordo com a questão"
                ></img>
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <Typography
                  color={"#000000"}
                  paddingLeft={"0.3em"}
                  fontSize={"1.25em"}
                  letterSpacing={0}
                  fontWeight={700}
                  fontFamily={"Inter, Helvetica, sans-serif"}
                  fontStyle={"normal"}
                  lineHeight={"100%"}
                  marginTop={"1.5em"}
                >
                  {isLoading === 1
                    ? "Aguarde, a carregar pergunta..."
                    : dado.question}
                </Typography>
              </Grid>
              <Grid item xs={12} textAlign={"center"} marginTop={"2vh"}>
                <CustomButton
                  title={"verdadeiro"}
                  type={"CheckCircleIcon"}
                  width={"13.25em"}
                  height={"3.6875em"}
                  correct={dado.correct === 1 ? "true" : "false"}
                  path={"response/" + dado.id}
                ></CustomButton>
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <CustomButton
                  title={"falso"}
                  type={"ClearIcon"}
                  width={"8.625em"}
                  height={"3.6875em"}
                  correct={dado.correct === 0 ? "true" : "false"}
                  path={"response/" + dado.id}
                ></CustomButton>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
